import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import { Trans } from 'lingui-react';

import messages from './messages';
import Wrapper from './NoSearchResultsWrapper';
import NoSearchResultsTitle from './NoSearchResultsTitle';
import NoSearchResultsTitleValue from './NoSearchResultsTitleValue';
import NoSearchResultsSubtitle from './NoSearchResultsSubtitle';

function NoSearchResults({ searchValue }) {
  return (
    <Wrapper>
      <FontAwesome name="search" />
      <NoSearchResultsTitle>
        <Trans id={messages.noResultsTitle} />
        <NoSearchResultsTitleValue>
          {` ${searchValue}`}
        </NoSearchResultsTitleValue>
      </NoSearchResultsTitle>
      <NoSearchResultsSubtitle>
        {searchValue && searchValue.length > 2 ?
          <Trans id={messages.noResultsNoMatch} />
          :
          <Trans id={messages.noResultsWrongQuery} />
        }
      </NoSearchResultsSubtitle>
    </Wrapper>
  );
}

NoSearchResults.propTypes = {
  searchValue: PropTypes.string.isRequired,
};

export default NoSearchResults;



// WEBPACK FOOTER //
// ./components/SearchResultsPanel/NoSearchResults.js